import { useQuery } from "@tanstack/react-query";
import { http } from "../../../utils";

export async function fetchNoticeById(id) {
  const { data } = await http(`/admin/notice/${id}`);

  return data;
}

export function useNoticeById(id) {
  const { data, ...raResult } = useQuery(["notice-detail", id], () =>
    fetchNoticeById(id)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
